"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
exports.CURRENCY_MASK_CONFIG = new core_1.InjectionToken("currency.mask.config");
//# sourceMappingURL=currency-mask.config.js.map


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src2078029388/src/~/ngx-currency-mask/src/currency-mask.config.js
// module id = p5+g
// module chunks = 6